import {Navbar, Container, Nav} from "react-bootstrap"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faUserSecret} from "@fortawesome/free-solid-svg-icons";
import { faGithub,faLinkedin, faWindows } from '@fortawesome/free-brands-svg-icons'
// import {logo} from "../assets/logo/user-secret-solid.svg"
import {useState, useEffect} from "react";
import hello from "../assets/images/hello.png";

  const NavBar = () => {
  const[activeLink,setActiveLink] = useState('home');
  const[scrolled, seScrolled]= useState(false);

    useEffect(()=>{
      const onScroll = () =>{
        if(window.scrollY > 50){
          seScrolled(true)
        } else {
          seScrolled(false);
        }
      }
      window.addEventListener("scroll", onScroll);
      return() => window.removeEventListener("scroll", onScroll);
    },[])

      const onUpdateActiveLink = (value) => {
        setActiveLink(value);
      }

  return (
    <Navbar id="navbar" bg="background-color: #282c34;" variant="dark" expand="lg" className={scrolled ? "scrolled": ""}>
      <Container>
      <Navbar.Brand id="brand" href="#home">
      <img src={hello} alt="Image" />{""}<h1 className="h1">KHealer</h1>            
          </Navbar.Brand>
          
        
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="#home" className={activeLink === 'home' ? 'active navbar-link' : 'navbar-link'} onClick={()=>onUpdateActiveLink('home')}><h1>Home</h1></Nav.Link>
            
            <Nav.Link href="#skills" className={activeLink === 'skills' ? 'active navbar-link' : 'navbar-link'} onClick={()=>onUpdateActiveLink('skills')}><h1>Skills</h1></Nav.Link> 

            <Nav.Link href="#about" className={activeLink === 'about' ? 'active navbar-link' : 'navbar-link'} onClick={()=>onUpdateActiveLink('about')}><h1>About</h1></Nav.Link> 

            <Nav.Link href="#connect" className={activeLink === 'about' ? 'active navbar-link' : 'navbar-link'} onClick={()=>onUpdateActiveLink('connect')}><h1>Contact</h1></Nav.Link> 
          </Nav>

          <span className="navbar-text">
            <div className="social-icon">
              <a href="https://github.com/kHealer"><FontAwesomeIcon className="icon" icon={faGithub}></FontAwesomeIcon></a>
              <a href="https://www.linkedin.com/in/safa-helvaci-032937226/"><FontAwesomeIcon className="icon" icon={faLinkedin}></FontAwesomeIcon></a>

            </div>

          </span>
          
        </Navbar.Collapse>
        
      </Container>
    </Navbar>
  );
}

export default NavBar;